import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Box, Checkbox} from 'views/components';
import {FilterSettings, translate} from 'views/module';

import FilterChipOption from './FilterChipOption';
import FilterOption from './FilterOption';
import Search from './Search';

const Filter = (props) => {
  const selection = props.selection;
  const updateFilter = props.updateFilter;
  const onClearFilter = props.onClearFilter;
  const filterOptions = props.filterOptions;
  const languagesFilter = props.languagesFilter || [];
  const languagesFilterOp = props.languagesFilterOp;
  const setLanguagesFilterOp = props.setLanguagesFilterOp;

  return (
    <Stack
      direction='row'
      alignItems={{md: 'center', xs: 'flex-start'}}
      flexWrap="wrap"
      sx={{
        width: '100%',
      }}
    >
      {
        filterOptions.caregiverName &&
        <Box sx={{p: 0.5}}>
          <Search
            selection={selection}
            filterOptions={filterOptions}
            updateFilter={updateFilter}
          />
        </Box>
      }
      <FilterOption
        updateFilter={updateFilter}
        filterOptions={filterOptions}
      />
      <FilterChipOption
        selection={selection}
        updateFilter={updateFilter}
        filterOptions={filterOptions}
      />
      {
        languagesFilter.length > 0 &&
        <Box sx={{px: 0.5}}>
          <Checkbox
            label={translate('career.jobDetail.NearbyCaregivers.RequireAllLanguages')}
            ariaLabel={translate('career.jobDetail.NearbyCaregivers.RequireAllLanguages')}
            checked={languagesFilterOp === 'AND'}
            onChange={(checked) => setLanguagesFilterOp(checked ? 'AND' : 'OR')}
            formControlSx={{m: 0}}
          />
        </Box>
      }
      <Box >
        <FilterSettings
          onClearFilter={onClearFilter}
        />
      </Box>
    </Stack>
  );
};

Filter.propTypes = {
  selection: PropTypes.object.isRequired,
  filterOptions: PropTypes.object.isRequired,
  updateFilter: PropTypes.func.isRequired,
  onClearFilter: PropTypes.func.isRequired,
  languagesFilter: PropTypes.arrayOf(PropTypes.string),
  languagesFilterOp: PropTypes.oneOf(['AND', 'OR']),
  setLanguagesFilterOp: PropTypes.func,
};
const mapStateToProps = (state) => ({
});


export default connect(mapStateToProps, dispatch)(React.memo(Filter));
